<div class="container rtl iran-sans">
    <div class="row gy-4">
        <div class="col-lg-6 order-2 order-lg-1 d-flex flex-column justify-content-center">
            <h1>
                <span>
                    تجربه بهتر با 
                </span>
                <span class="violet">
                    خدمات آنلاین سلامت
                </span>
                <!-- <span class="">
                    دکتر می
                </span> -->
            </h1>
            <h2>
                دکتر می، بستر الکترونیک ارائه خدمات سلامت برای مردم و پزشکان است.
            </h2>
            <div>
                <a href="#services" class="btn-get-started scrollto">خدمات ما</a>
            </div>
        </div>
        <div class="col-lg-6 order-1 order-lg-2 hero-img">
            <!-- <img src="assets/img/hero-img.svg" class="img-fluid animated" alt=""> -->
            <img src="assets/img/happy-doctor.png" class="img-fluid" alt="">
        </div>
    </div>
</div>